import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Moment from "react-moment";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";

import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import configFromEnv from "../../../../services/configuration";
import {
  currencyFormat,
  formatDate,
  formatDateTime,
} from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import {
  addPurchaseOrder,
  addRfxNr,
  getpOPaymentConfirmList,
  pODeliverConfirmNr,
  pOPaymentConfirmNr,
  quotationListInfo,
} from "../../../../redux/feature/profit_ledger/profitLedgerSlice";
import { addInquiryID } from "../../../../redux/feature/customer_app/preSalesSlice";
import DispatchPurchaseOrderModal from "./DispatchPurchaseOrderModal";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const CustomerDeliveryListV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "");

  let poDocData = useSelector((state) => state?.customer?.pOPaymentConfirm); // User Details from Store
  let poDocDataTable = useSelector(
    (state) => state?.customer?.pOPaymentConfirm?.pagination,
  ); // User Details from Store
  const [data, setData] = useState([]);
  // console.log(">>data",data)
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    const normalizedData = Array.isArray(itemLevelData)
      ? itemLevelData
      : itemLevelData
        ? [itemLevelData]
        : [];

    setItemLevelData(normalizedData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(CustomerConstants.CUSTOMER_V2_RFQ_DETAIL);
  };
  const detailedPage = (poNumber) => {
    dispatch(addPurchaseOrder(poNumber));
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DETAILS);
  };
  // eslint-disable-next-line
  const deliveryDetailedPage = (number) => {
    dispatch(pOPaymentConfirmNr(number));
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_DETIALS);
  };

  const detailedPageQuotation = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj));
    navigate(CustomerConstants.CUSTOMER_V2_QUOTATION_DETAILS);
  };

  const detailedPageindent = (inquiryID) => {
    dispatch(addInquiryID(inquiryID));
    navigate(CustomerConstants.CUSTOMER_V2_INDENT_DETAILS);
  };
  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    {
      name: "Delivery Nr",
      cell: (row) => (
        <span
          className="btnInfo d-flex justify-content-center"
          // onClick={() => deliveryDetailedPage(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </span>
      ),
      width: "150px",
    },
    {
      name: "Po Nr",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Purchase Type",
      selector: (row) => row.productType || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.productType} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          {/* <span className="suppliersIcon"> {row.items?.length} </span> */}
          <span className="suppliersIcon">
            {Array.isArray(row.items) ? row.items.length : row.items ? 1 : 0}
          </span>
        </>
      ),
      width: "120px",
    },

    {
      name: "Payment",
      // id: "invoiceNr",
      cell: (row) => (
        <>
          <span
            onClick={() => showDispatchInvoice(row)}
            className="fs-5 p-2 rounded hover:bg-blue-500 hover:text-white cursor-pointer"
          >
            <i class="bi bi-journal-text"></i>
          </span>
          {/* {row.paymentStatus && row.paymentStatus === "Confirmed" ? (
            <>
              <span
                onClick={() => showDispatchInvoice(row)}
                className="fs-5 p-2 rounded hover:bg-blue-500 hover:text-white cursor-pointer"
              >
                <i class="bi bi-journal-text"></i>
              </span>
            </>
          ) : (
            <>
              <button
                className="btnTable"
                onClick={() => showDispatchInvoice(row)}
              >
                Payment
              </button>
            </>
          )} */}
        </>
      ),

      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => formatDate(row?.purchasingDocumentDate) || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "PO Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.qtnTotal).toFixed(2))}
        </span>
      ),
      selector: (row) => row.qtnTotal || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "Currency ",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
        </>
      ),
      selector: (row) => row.currency || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Supplier",
      selector: (row) => row.AssociateNumber,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.AssociateNumber} </p>
          <p className="m-0 p-0">{row.organisationName} </p>
        </div>
      ),
    },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeDesc} </span>
        </>
      ),
      width: "150px",
    },
    // {
    //   name: "Indent Number",
    //   selector: (row) => row.item?.inquiryNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Indent Nr",
      selector: (row) => row.inquiryNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageindent(row.inquiryNr)}
        >
          {row.inquiryNr || "-"}{" "}
        </button>
      ),
      width: "140px",
    },
    {
      name: "RFQ",
      selector: (row) => row.rfxNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}{" "}
        </button>
      ),
      width: "160px",
    },
    {
      name: "Quotation Nr",
      selector: (row) => row.quotationNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageQuotation(row.quotationNr)}
        >
          {row.quotationNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              // onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];
  const lineItemColInfo = [
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.indentQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{formatDate(row?.deliveryDate)}</span>,
      width: "220px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const loadInitialPoData = async () => {
    setData(poDocData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "Get_CUST_Payment_List",
      // module: "PO",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getpOPaymentConfirmList(obj));
    setData(poDocData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_CUST_Payment_List",
      // module: "PO",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getpOPaymentConfirmList(obj));
    setData(poDocData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_CUST_Payment_List",
      // module: "PO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getpOPaymentConfirmList(obj));
  };

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_CUST_Payment_List",
      // module: "PO",
      page: 1,
      per_page: 10,
    };
    dispatch(getpOPaymentConfirmList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialPoData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poDocData]);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  // const cancelModalShow = () => {
  //   setCancelModalStatus(true);
  // };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };

  //invoice
  const [getModalEditDispatch, setModalEditDispatch] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const showDispatchInvoice = (rowData) => {
    dispatch(pODeliverConfirmNr(rowData?.dispatchNr || ""));
    setModalEditDispatch(true);
    setInvoiceData(rowData);
  };
  const hideInvoiceModal = () => {
    setModalEditDispatch(false);
    // setEwayBillData(null);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Payment Confirmed</h2>
                <p className="subText">Lists of Payment Order and Details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Payment Confirm List</span>
                      <span className="subHeaderTitle">
                        View of Payment Confirm and Status{" "}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={poDocData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={poDocDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        // type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <DispatchPurchaseOrderModal
        show={getModalEditDispatch}
        onHide={() => hideInvoiceModal()}
        invoiceinfo={invoiceData}
        // onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
    </main>
  );
};

export default CustomerDeliveryListV2;
